import React from "react";
import { connect } from "react-redux";
import styled from "styled-components";
import { i18n } from "../../services";
import { Doc } from "../../models";
import { Menu, Toolbar, ResizeImage } from "../../components/Editor";
import Name from "../../components/Editor/Name";
import Contents from "../../components/Editor/Contents";

import { fetchDoc } from "../../reducers/docs/actions";
import { fetchPage, fetchPages } from "../../reducers/pages/actions";
import { fetchDocUser } from "../../reducers/doc_users/actions";

import { AutoComplete } from "../../lib";
import { setWindowTitle } from "../../helpers";
import { UD_EDITOR, UD_AUTHOR, UD_READER } from "../../settings";
import { AppState } from "../../store";

const Container = styled.div<{ enableDarkTheme: boolean }>`
    position: relative;
    left: 0;
    top: 0;
    width: 100vw;
    height: 100vh;
    overflow: hidden;
    background-color: ${(p) => (p.enableDarkTheme ? "#000" : "#fff")};
`;

const mapStateToProps = function (
    { user, docs, doc_users, pages, settings }: AppState,
    {
        match: {
            params: { doc_id, page_id },
        },
    }: {
        match: { params: { doc_id: string; page_id: string } };
    }
) {
    // @ts-ignore
    const user_id = user.get("id");
    const param_doc_id = parseInt(doc_id);
    const param_page_id = parseInt(page_id);

    return {
        doc_id: param_doc_id,
        page_id: param_page_id,
        user_id,
        settings,
        pages,
        // @ts-ignore
        doc: docs.get(param_doc_id) as Map<string, any>,
        // @ts-ignore
        page: pages.get(param_page_id) as Map<string, any>,
        // @ts-ignore
        doc_user: doc_users.get(`${param_doc_id}-${user_id}`) as Map<
            string,
            any
        >,
    };
};
const mapDispatch = {
    fetchDoc,
    fetchPage,
    fetchPages,
    fetchDocUser,
};

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatch;

type Props = StateProps & DispatchProps;
type State = {};

class EditorPage extends React.Component<Props, State> {
    static paths = ["/app/e/:doc_id/:page_id"];
    static requiresAuth = true;

    componentDidMount() {
        this.fetch();
        setWindowTitle("اُردو اِیڈیٹر");
    }

    componentWillReceiveProps(newProps: Props, _newState: State) {
        newProps.doc && setWindowTitle(newProps.doc.get("name"));
    }

    componentWillUnmount() {
        setWindowTitle(i18n.get("site.title"));
    }

    fetch() {
        const { user_id } = this.props;
        const { doc_id, page_id } = this.props;
        if (!this.props.doc) {
            this.props.fetchDoc(doc_id);
        }

        this.props.fetchDocUser({ doc_id, user_id });
        this.props.fetchPage({ doc_id, page_id });

        setTimeout(() => {
            this.props.fetchPages({ doc_id });
            Doc.save(null, `${doc_id}/accessed`);
        }, 2000);
    }

    render() {
        const { doc_id, page_id, page, doc_user, settings } = this.props;
        // @ts-ignore
        const enableDarkTheme = settings.get("enableDarkTheme") as boolean;
        const status = doc_user && (doc_user.get("status") as string);
        const props = {
            doc_id,
            page_id,
            enableDarkTheme,
            readOnly: status === UD_READER,
            parent_id: (page && page.get("parent_id")) || 0,
            canAdminister: [UD_EDITOR, UD_AUTHOR].includes(status),
        };

        return (
            <Container {...props}>
                <Name {...props} page={this.props.page} />
                <Contents {...props} />
                {/*<Comments {...props} />*/}
                {/*<Communicator {...props} />*/}
                <Menu {...props} />
                <Toolbar {...props} />
                <ResizeImage {...props} />
                <AutoComplete enableDarkTheme={enableDarkTheme} />
            </Container>
        );
    }
}

export default connect(mapStateToProps, mapDispatch)(EditorPage);
